import { AccredibleBaseInputInterface } from '@accredible-frontend-v2/forms/utils';
import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { AccredibleRadioGroupOption } from './radio-input.model';

let nextUniqueId = 0;

@Component({
  selector: 'accredible-radio-input',
  templateUrl: './radio-input.component.html',
  styleUrls: [`./radio-input.component.scss`],
  // We are not using ChangeDetectionStrategy.OnPush because the material input component
  // does not detect changes on the formControlRef (invalid, dirty or touched)
  // and errors do not get triggered with formGroup.markAllAsTouched() alone
})
export class AccredibleRadioInputComponent implements AccredibleBaseInputInterface {
  @Input()
  formControlRef: UntypedFormControl;
  @Input()
  label: string;
  @Input()
  required = false;
  @Input()
  options: AccredibleRadioGroupOption[];
  @Input()
  direction: 'horizontal' | 'vertical' = 'horizontal';
  @Input()
  color: ThemePalette = 'accent';
  @Input()
  size: 'normal' | 'large' = 'normal';
  @Input()
  showLabel = true;

  radioGroupLabelId = nextUniqueId++;
}
